import { ele } from "cables-shared-client";
import api from "../api.js";
import web from "../index.js";

export default class PageSearch
{
    constructor(targetElement)
    {
        this.lastOptions = {
            "what": "ppub",
            "order": "date",
            "limit": 48,
            "offset": 0
        };
        this.lastTerm = "";

        const headSearch = ele.byId("headsearch");
        if (headSearch)
        {
            let searchWord = headSearch.value;
            this.lastTerm = searchWord;
            this.search(searchWord, { "what": "ppub" });
        }

        const url = new URL(window.location);
        let what = "";
        if (window.location.hash)
        {
            what = window.location.hash.split("#", 2)[1];
        }
        what = what || url.searchParams.get("w") || "all";

        this.lastOptions.what = what;
        this.lastOptions.order = url.searchParams.get("or");
        this.lastOptions.limit = url.searchParams.get("l") || 48;
        this.lastOptions.offset = url.searchParams.get("o") || 0;

        const eleheadsearch = ele.byClassAll("searchformsmall");
        if (eleheadsearch.length > 0) eleheadsearch[0].style.display = "none";
    }

    search(term, options = {}, cb = () => {}, limit = 48, offset = 0)
    {
        const targetEle = options.targetEle;

        let params = "s=" + term;
        if (options.what !== this.lastOptions.what)
        {
            offset = 0;
        }
        this.lastOptions = options;
        if (!options.count)
        {
            this.lastOptions.limit = limit;
            this.lastOptions.offset = offset;
        }
        this.lastTerm = term;

        if (options.order)
        {
            params += "&or=" + options.order;
            const orderDropdown = document.getElementById("order");
            if (orderDropdown)
            {
                orderDropdown.value = options.order;
            }
        }
        if (options.what) params += "&w=" + options.what;

        if (options.count)
        {
            params += "&count=" + true;
        }
        else
        {
            limit = Number(limit);
            offset = Number(offset);
            if (limit || limit === 0)
            {
                params += "&l=" + limit;
            }
            if (offset)
            {
                params += "&o=" + offset;
            }
        }

        let url = "search?" + params;

        const doUserSearch = term ? term.length > 2 : false;
        if (options.what === "u" && !doUserSearch)
        {
            if (cb) cb(null, { "numResults": 0 });
            const usersTab = ele.byId("tab_users");
            if (usersTab.classList.contains("active")) ele.show(usersTab);
        }
        else
        {
            api.get(
                url,
                (result) =>
                {
                    if (cb) cb(null, result, targetEle);
                },
                (res) =>
                {
                    console.log(res);
                });
        }
    }

    getCount(targetEle, fromUserInteraction = false)
    {
        const options = JSON.parse(JSON.stringify(this.lastOptions));
        options.count = true;
        options.what = targetEle.dataset.tabName;
        options.targetEle = targetEle;

        if (targetEle.id === "tab_users")
        {
            const doUserSearch = this.lastTerm ? this.lastTerm.length > 2 : false;
            if (!doUserSearch)
            {
                if (targetEle.classList.contains("active"))
                {
                    targetEle.innerHTML += " <span class=\"tab-bar-count\">(0)</span> ";
                    ele.show(targetEle);
                }
                return;
            }
            else
            {
                ele.show(targetEle);
            }
        }

        this.search(this.lastTerm, options, (err, re) =>
        {
            targetEle.innerHTML += " <span class=\"tab-bar-count\">(" + re.numResults + ")</span> ";
        });
    }

    showResults(targetEle, fromUserInteraction = false)
    {
        const term = this.lastTerm;
        const options = {
            "what": targetEle.dataset.tabName,
            "count": false,
            "order": this.lastOptions.order
        };

        const orderEle = ele.byId("ordercontrols");
        if (orderEle)
        {
            if (options.what === "ops" || options.what === "u")
            {
                ele.hide(orderEle);
            }
            else
            {
                ele.show(orderEle);
            }
        }

        const limit = this.lastOptions.limit;
        const offset = this.lastOptions.offset;
        if (fromUserInteraction)
        {
            let historyUrl = "/patches?s=" + term;
            if (options.order) historyUrl += "&or=" + options.order;
            historyUrl += "#" + options.what;
            history.pushState(null, null, historyUrl);
        }
        else
        {
            if (options.what === "topMonth" && !options.order)
            {
                options.order = "favs";
            }
        }

        this.search(term, options, (err, result) =>
        {
            let html = "";
            let i = 0;
            const append = false;

            if (result.tags && result.tags.length > 0)
            {
                html += "<div class=\"cute-12-phone\">Related tags: ";
                for (i = 0; i < result.tags.length; i++)
                {
                    if (result.tags[i].tag && result.tags[i].tag !== "") html += "<a class=\"tag \" href=\"/patches?s=" + result.tags[i].tag + "\">" + result.tags[i].tag + "</a> ";
                }

                html += "</div><br/>";
            }

            if (result.projects)
            {
                for (i in result.projects)
                {
                    const project = result.projects[i];
                    let displayedDate = "published";
                    if (project.allowEdit) displayedDate = "updated";
                    const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername }, "displayedDate": displayedDate });
                    html += web.getHandleBarHtml("project", { "project": project, "projectInfo": projectInfo });
                }
            }

            if (result.users)
            {
                for (i in result.users)
                {
                    html += web.getHandleBarHtml("user", result.users[i]);
                }
            }

            if (result.items)
            {
                for (i in result.items)
                {
                    html += web.getHandleBarHtml("op", result.items[i]);
                }
            }

            if (html.length === 0)
            {
                html = "<div class=\"cute-4-tablet cute-3-desktop left\"><h3>No Results</h3></div>";
            }

            if (!append) targetEle.innerHTML = html;
            else targetEle.innerHTML += html;
            if (result.pagination)
            {
                web.tabs.initPagination(ele.byId("pagination"), result.pagination, limit, offset, (newLimit, newOffset) =>
                {
                    ele.show(ele.byId("pagination"));
                    this.lastOptions.limit = newLimit;
                    this.lastOptions.offset = newOffset;
                    this.setWhat(options.what, options.order, newLimit, newOffset);
                });
            }
            else
            {
                ele.hide(ele.byId("pagination"));
            }
        }, limit, offset);
    }

    setWhat(val, order, limit, offset)
    {
        limit = Number(limit);
        offset = Number(offset);
        let newSearch = "?s=" + this.lastTerm;
        if (order)
        {
            newSearch += "&or=" + order;
        }
        if (limit || limit === 0)
        {
            newSearch += "&l=" + limit;
        }
        if (offset)
        {
            newSearch += "&o=" + offset;
        }
        window.location.search = newSearch;
        history.pushState(null, null, "#" + val);
    }

    setOrder(val)
    {
        this.lastOptions.order = val;
        this.setWhat(this.lastOptions.what, val, this.lastOptions.limit, this.lastOptions.offset);
    }
}
